import Application from '@/store/Models/Application'
import axios from "axios";
import {getInstance} from "@/auth";
export default {

    // From MyLeads
    getApplications(agent_code, filters, options) {
        Application.commit((state) => {
            state.loading = true
        })
        var params = {
            ...options,
            ...filters
        }
        this.cancelQRequest("getApplicationsQ");
        return this.getRequest('/api/private/agent/' + agent_code + '/applications', params, "getApplicationsQ").then(function(json) {
            if (typeof json.meta == 'undefined') {
                return json;
            }
            Application.commit((state) => {
                state.loading = false
                state.total = json.meta.total
                if (json.meta.filters) {
                    state.availableFilters = json.meta.filters
                }
            })
            return json;
        })
    },

    getApplication(id) {
        this.cancelQRequest("getApplicationQ");
        return this.getRequest('/api/private/applications/' + id, {}, "getApplicationQ").then(function(json) {
            return json;
        })
    },

    saveApplication(agent_code, application){
        if (application.ID == null) {
            var req = this.postRequest('/api/private/agent/' + agent_code + '/applications', application)
        } else {
            var req = this.putRequest('/api/private/agent/' + agent_code + '/applications/' + application.ID, application)
        }
        return req.then(function(json) {
            return json
        },
        function(error) {
            return error
        })
    },

    bulkUpdateApplications(applications){
        return this.putRequest('/api/private/applications/bulk_update', applications).then(function(json) {
            return json
        },
        function(error) {
            return error
        })
    },

    downloadApplicationPdf(application) {
        const url = '/api/private/applications/' + application.ID + '/pdf';

        // this is a sensitive file, send data instead of a public url
        return getInstance().getTokenSilently().then( token => {
            return axios.get(url, {
                responseType: 'arraybuffer',
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        });
    },

    toggleDemoMode() {
        return this.getRequest('/api/admin/toggle-demo-mode', {}, "getApplicationQ").then(function(json) {
            return json;
        })
    }
}
